const style = '@keyframes skapa-shine{to{background-position:0 100%}}:host{animation:skapa-shine 2s 20;background-color:rgb(var(--colour-neutral-3,223,223,223));background-image:linear-gradient(90deg,rgba(var(--colour-neutral-1,255,255,255),0) 40%,rgba(var(--colour-neutral-2,245,245,245),.5) 50%,rgba(var(--colour-neutral-1,255,255,255),0) 60%);background-origin:border-box;background-position:100% 0;background-repeat:no-repeat;background-size:250% 100%;border:1px solid #0000;box-sizing:border-box;cursor:progress;display:inline-block;height:1em;line-height:inherit;width:100%}:host([skapa-rtl]){animation-direction:reverse}';
const lightStyles = '@keyframes skapa-shine{to{background-position:0 100%}}';
import { RTLObserver } from "@ingka/webc-tools";
import { SkapaElement } from "@ingka/skapa-webc-element";
function generateTemplate({ html, prefixReplacer }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${style}
    </style>
    <slot></slot>
    <slot name="light-styles"></slot>
  `;
  const lightStyle = document.createElement("style");
  lightStyle.slot = "light-styles";
  lightStyle.innerHTML = prefixReplacer(lightStyles.toString());
  return { main: template, lightStyle };
}
class Skeleton extends SkapaElement {
  constructor() {
    super();
    this.gatherProperties(["width", "height"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const { main, lightStyle } = this.getTemplates(generateTemplate);
    shadow.append(main.content.cloneNode(true));
    this.lightStyleNode = lightStyle.cloneNode(true);
  }
  connectedCallback() {
    super.connectedCallback();
    this.append(this.lightStyleNode);
    RTLObserver.addTarget(this);
  }
  disconnectedCallback() {
    RTLObserver.removeTarget(this);
  }
  get width() {
    return this.getAttribute("width") || "100%";
  }
  set width(value) {
    this.setAttribute("width", value);
  }
  get height() {
    return this.getAttribute("height") || "1em";
  }
  set height(value) {
    this.setAttribute("height", value);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue !== null)
      this.style.setProperty(name, newValue);
    else
      this.style.removeProperty(name);
  }
}
Skeleton.skapaTagName = "skeleton";
Skeleton.skapaDependencies = [];
Skeleton.observedAttributes = ["width", "height"];
export {
  Skeleton
};
